import { authStore } from '../auth/authStore'

export interface RequireAuthInput {
  href: string
}

export class AuthRedirect extends Error {
  to = '/login'
  constructor(public search: { next: string }) {
    super('Redirect to /login')
    this.name = 'AuthRedirect'
  }
}

export async function requireAuth(input: RequireAuthInput): Promise<void> {
  let state = authStore.snapshot()
  if (state.status === 'loading') state = await authStore.waitUntilSettled()
  if (state.status !== 'signed-in') {
    throw new AuthRedirect({ next: withoutEmail(input.href) })
  }
}

/**
 * The location to return to, minus any `email` query parameter. Old bookmarks of the
 * create-user page still carry `?email=`, and `next` puts the whole location in the
 * /login URL, which every log on the way records. Everything else is kept.
 */
function withoutEmail(href: string): string {
  const url = new URL(href, 'http://local.invalid')
  if (!url.searchParams.has('email')) return href
  url.searchParams.delete('email')
  return url.pathname + url.search + url.hash
}
